import { z } from 'zod';
import { DateTimeUtcService, TimeService } from '@mews-framework/datetime';
import { DateTimeLocalizationInfo } from '@mews-framework/globalization';
import { CustomErrorParams, CustomErrorType } from '../../CustomErrorType';
import { dateStringValidationError } from './common';

export const createTimeStringSchema = (localizationInfo: DateTimeLocalizationInfo) =>
    z.string().superRefine((value, ctx) => {
        if (!TimeService.isValidShortString(value, localizationInfo)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                params: { errorType: CustomErrorType.TimeString } satisfies CustomErrorParams,
                fatal: true,
            });

            return z.NEVER;
        }

        return value;
    });

export const timeIsoStringSchema = z.string().superRefine((value, ctx) => {
    if (!TimeService.isValidTimeString(value)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            params: { errorType: CustomErrorType.TimeString } satisfies CustomErrorParams,
            fatal: true,
        });
        return z.NEVER;
    }
    return value;
});

export const dateTimeUtcStringSchema = z.string().superRefine((value, ctx) => {
    if (!DateTimeUtcService.isValidString(value)) {
        ctx.addIssue(dateStringValidationError);
        return z.NEVER;
    }

    return value;
});
